/**
 * COMM-7 (client half): input limits that match the server's Zod schemas, so a browser stops
 * typing at the limit instead of the API answering 400. Keep in step with
 * backend/src/lib/validations/{messaging,community,ai-tutor}.ts.
 */
export const COMMS_LIMITS = {
  announcementTitle: 200,
  announcementBody: 10_000,
  directMessage: 5_000,
  forumThreadTitle: 200,
  forumThreadBody: 10_000,
  forumReply: 10_000,
  aiTutorQuestion: 2_000,
} as const;
